<template>
    <card>
       <template slot="header">
          <h3 class="card-title">Inactive Employee</h3>
       </template>
       <nav class="row">
          <ol class="breadcrumb arr-right bg-breadcrum">
             <li class="breadcrumb-item">
                <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
             </li>
             <li class="breadcrumb-item">
                <router-link to="/hr/employeelist">Active Employees</router-link>
             </li>
             <li class="breadcrumb-item active">Inactive Employees</li>
             <li class="breadcrumb-item">
                <router-link to="/hr/dependents">Dependents</router-link>
             </li>
             <li class="breadcrumb-item">
                <router-link to="/hr/workshifts">Workshifts</router-link>
             </li>
             <!-- NEW ADDITIONAL -->
             <li class="breadcrumb-item">
                <router-link to="/hr/scheduleadjustment">Schedule Adjustment</router-link>
             </li>
             <li class="breadcrumb-item">
                <router-link to="/hr/undertimerequest">Undertime Request</router-link>
             </li>
             <li class="breadcrumb-item">
                <router-link to="/hr/nterequest">NTE Tracker</router-link>
            </li> 
            <li class="breadcrumb-item">
                <router-link to="/hr/coaching/records">Employee Coached</router-link>
              </li>
          </ol>
       </nav>
       <hr style="margin-top:-10px"/>
       <div class="row">
          <div class="col-md-5">
             <p><i class="fa fa-search"></i> Search Employee</p>
             <input type="test" v-model="search" class="form-control" placeholder="Search..."> 
          </div>
          <div class="col-md-3">
             <div class="form-group">
                <p><i class="fa fa-filter"></i>&nbsp;Filter by Position:</p>
                <select v-model="filter_by_position" class="form-control" required>
                   <option value="">Default</option>
                   <option v-for="pos in positions"  v-text="pos.pos_name"></option>
                </select>
             </div>
          </div>
          <div class="col-md-2">
             <div class="form-group">
                <p><i class="fa fa-filter"></i>&nbsp;Filter by Status:</p>
                <select v-model="filter_by_status" class="form-control">
                   <option value="">Default</option>
                   <option value="terminated">terminated</option>
                   <option value="resigned">resigned</option>
                   <option value="awol">AWOL</option>
                </select>
             </div>
          </div>
          <div class="col-md-1">
             <div class="form-group">
                <p><i class="fa fa-sort-amount-asc"></i>&nbsp;Order by </p>
                <select v-model="order_by" class="form-control" required>
                   <option value="">Default</option>
                   <option value="-1">ASC</option>
                   <option value="1">DESC</option>
                </select>
             </div>
          </div>
          <div class="col-md-1">
             <div class="form-group">
                <p><i class="fa fa-sort-numeric-asc"></i>&nbsp;Display</p>
                <select v-model="page_limit" class="form-control" required>
                   <option value="">Default</option>
                   <option value="5">5</option>
                   <option value="10">10</option>
                   <option value="25">25</option>
                   <option value="50">50</option>
                   <option value="100">100</option>
                   <option value="500">500</option>
                </select>
             </div>
          </div>
       </div>
       <hr/>
        <!-- PAGINATION -->
        <b-pagination
        v-model="curentPage"
        :total-rows="items.length"
        :per-page="perPage"
         aria-controls="my-table"
         align="right"
         first-text="First"
         prev-text="Prev"
         next-text="Next"
         last-text="Last"
        ></b-pagination>
        <!-- END PAGINATION -->
        <hr/>
       <div class="table-responsive ">
          <table class="table table-striped table-hover " v-loading="loading">
             <thead>
                <tr>
                   <th>#</th>
                   <th>Employee Name</th>
                   <th>Designation</th>
                   <th>Address</th>
                   <th><i class="fa fa-calendar"></i>Joined date</th>
                   <th>Status</th>
                  
                   <!-- <th>Action</th> -->
                </tr>
             </thead>
             <tbody>
                <tr v-for="item,index in computedEmployee">
                   <template v-if="item === 'no data found'">
                      <td colspan="100%">
                         <h4>  <i class="fa fa-database"></i> Empty Records ...</h4>
                      </td>
                   </template>
                   <template v-else>
                      <td>{{index + 1}}.</td>
                      <td> {{item.full_name  | capitalize }} {{item.suffix}}</td>
                      <td>{{item.position_name}}</td>
                      <td>
                        <i class="fa fa-map-marker"></i>&nbsp;
                        <template v-if="item.current_address.length < 30">{{item.current_address | capitalize}}</template>
                        <template v-if="item.current_address.length >= 30">{{ item.current_address.substring(0,30)+"..." | capitalize}}</template>
                     </td>
                      <td>{{ getDate(item.employment_date) }}</td>
                      <td>
                         <span v-if="item.status == 'resigned'">
                         <i class="fa fa-flag text-danger"></i>&nbsp;{{item.status}}
                         </span>
                         <span v-else-if="item.status == 'terminated'">
                         <i class="fa fa-flag text-danger"></i>&nbsp;{{item.status}}
                         </span>
                         <span v-else-if="item.status == 'awol'">
                         <i class="fa fa-flag text-warning"></i>&nbsp;{{item.status}}
                         </span> 
                      </td>
                    
                      <!-- <td width="115">
                         <router-link :to="{name: 'edit-info', params: { id: item.id }}" v-b-tooltip.hover title="click to view details and modify records" class="btn btn-xs"><i class="fa fa-pencil"></i>modify</router-link>
                      </td> -->
                   </template>
                </tr>
             </tbody>
          </table>
          <!-- PAGINATION NATIVE WAY -->
          <div class="row">
                <div class="col-md-6">
                    <p style="color:#9a9a9a">Page {{curentPage}} out of {{total_item}} records</p>
                </div>
                <div class="col-md-6">
                  <b-pagination
                      v-model="curentPage"
                      :total-rows="items.length"
                      :per-page="perPage"
                      aria-controls="my-table"
                      align="right"
                      first-text="First"
                      prev-text="Prev"
                      next-text="Next"
                      last-text="Last"
                  ></b-pagination>
                </div>
             </div>
             <!-- END PAGINATION -->
       </div>
       <!-- If Lost Connection on Server -->   
       <template v-if="display_indicator === 1">
          <center>
             <br/><br/>
             <img  src="/static/img/warning.png"  width="225" height="190">
             <h1>You've lost your network connection</h1>
             <h3>Check your wireless settings, or your network cable, and reload the page.</h3>
             <br/><br/>
          </center>
       </template>
    </card>
 </template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
export default {
  components: {
    Card,
  },

  data() {
    return {
      items: [],
      positions: [],
      //filter
      filter_by_position: '',
      filter_by_status: '',
      search: '',
      order_by: '',
      sortAsc: true,
      //pagination
      page_limit: '',
      start_page: 1,
      loading: true,
      //Indicator
      display_indicator: '',
      //PAGINATION
      perPage: 100,
      curentPage: 1
    }
  },

  mounted: function () {
    this.get_employees()
    this.get_positions()
  },

  methods: {

    get_employees() {
      axios.get('api/resigned')
        .then(response => {
          this.items = response.data
          this.display_indicator = 2;
          this.loading = false
        })
        .catch(e => {
          console.log(e.response)
          this.display_indicator = 1;

        })
    },

    get_positions() {
      axios.get('api/positions')
        .then(response => {
          this.positions = response.data
        })
        .catch(e => {
          console.log(e.response)
        })

    },
  },
  computed: {

    // PAGINATION
    offset() {
      return (this.start_page - 1) * this.page_limit;
    },
    limit() {
      return this.offset + this.page_limit;
    },
    total_item() {
      return this.items.length
    },


    computedEmployee() {
      let filtered = this.items
      // USE IN PAGINATION 
      let start = (this.curentPage - 1) * this.perPage
      let end = this.curentPage * this.perPage
      filtered = filtered.slice(start, end);
      if (filtered.length > 0) {
        // SEARCH BY EMPLOYEE FULLNAME  
        if (this.search) {
          filtered = filtered.filter(
            item => item.full_name.toLowerCase().indexOf(this.search) > -1
          );
          return filtered
        }
        // FILTER BY POSITION
        if (this.filter_by_position) {
          filtered = filtered.filter(
            item => item.position_name.toLowerCase() === this.filter_by_position.toLowerCase()
          );
          return filtered
        }

        // FILTER BY STATUS
        if (this.filter_by_status) {
          filtered = filtered.filter(
            item => item.status.toLowerCase() === this.filter_by_status.toLowerCase()
          );
          return filtered
        }

        // SORTING NUMBER OF DISPLAY
        if (this.page_limit) {
          filtered = filtered.slice(this.offset, this.limit);
          return filtered
        }

        // ORDER BY ASC AND DESC COMBOBOX
        if (this.order_by) {
          filtered = filtered.slice(0).sort((a, b) => a.full_name < b.full_name ? this.order_by : -this.order_by)
          return filtered
        }
      }
      return filtered
    }
  },

}
</script>
  




// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/todo-resigned.vue